import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/404.png'


const _withScopeId = n => (_pushScopeId("data-v-acb1c088"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p404" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t1" }, "404", -1))
const _hoisted_4 = { class: "t2" }

import { computed } from 'vue'
import { useStore } from 'vuex';
import i18, { State as I18State } from '@/store/i18'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const i18Data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18Data.value.texts[i18Data.value.lang.list[i18Data.value.lang.now]].common)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(lang).p404), 1)
  ]))
}
}

})